import { ChakraTheme, Colors, extendTheme } from '@chakra-ui/react';
import { colors } from '@waitroom/config';
import Alert from './alert';
import Avatar from './avatar';
import Badge from './badge';
import { breakpoints } from './breakpoints';
import Button from './button';
import Checkbox from './checkbox';
import CloseButton from './close-button';
import Container from './container';
import FormError from './form-error';
import FormLabel from './form-label';
import Heading from './heading';
import IconBox from './iconBox';
import Input from './input';
import layerStyles from './layerStyles';
import Menu from './menu';
import Modal from './modal';
import PinInput from './pin-input';
import Popover from './popover';
import Progress from './progress';
import Radio from './radio';
import radius from './radius';
import Select from './select';
import shadows from './shadows';
import sizes from './sizes';
import styles from './styles';
import Switch from './switch';
import Tabs from './tabs';
import Tag from './tag';
import Textarea from './textarea';
import Tooltip from './tooltip';
import typography from './typography';

export type Theme = ChakraTheme & {
  colors: typeof colors & Colors;
};

const theme = extendTheme({
  breakpoints,
  ...typography,
  layerStyles,
  sizes,
  colors,
  radii: radius,
  shadows,
  styles,
  config: {
    useSystemColorMode: false,
    initialColorMode: 'light',
  },
  components: {
    Alert,
    Avatar,
    Badge,
    Button,
    Checkbox,
    CloseButton,
    Container,
    FormError,
    FormLabel,
    Heading,
    IconBox,
    Input,
    Menu,
    Modal,
    Progress,
    PinInput,
    Popover,
    Radio,
    Select,
    Switch,
    Tabs,
    Tag,
    Textarea,
    Tooltip,
  },
}) as Theme;

export default theme;
